module.exports = __webpack_public_path__ + "static/media/dungeon.95177979.svg";